import { Badge, Button, Col, DatePicker, Dropdown, Row, Select } from "antd";
import { Field, Form, Formik } from "formik";
import React, { FC, useEffect, useState } from "react";
import "./dashboardFilter.scss";
import FilterIcon from "../../../assets/icons/filter-icon-filled.svg";
import DatePickerField from "../../../shared/components/DatePickerField";
import DropdownField from "../../../shared/components/DropdownField";
import { MetaModel } from "../../../models/CourseModels/SubjectModel/subject.model";
import CalendarIcon from "../../../assets/icons/calendar-primary.svg";
import ButtonComponent from "../../../shared/components/ButtonComponent";
import BoardService from "../../../services/CourseServices/BoardService/board.service";
import CommonService from "../../../services/CommonService/common.service";
import { deserialize } from "serializr";
import DashboardService from "../../../services/DashboardService/dashboard.service";
import { DashboardFilterModel } from "../../../models/DashboardModel/DashboardFilterModel/dashboardFilter.model";
import moment from "moment";

import AuthContainer from "../../../store/container/AuthContainer";
import SectionService from "../../../services/InstituteService/section.service";

const { RangePicker } = DatePicker;
interface DashboardFilterProps {
  applyHandler: (values: DashboardFilterModel) => void;
  clearHandler: () => void,
  autoFilter?: boolean
  filterFor?: string,
  user: any;
}

const DashboardFilter: FC<DashboardFilterProps> = (props) => {
  const {
    applyHandler,
    clearHandler,
    autoFilter = false,
    filterFor,
    user
  } = props;

  const [initialValues, setInitialValues] = useState<DashboardFilterModel>({});
  const [defaultValues, setDefaultValues] = useState<DashboardFilterModel>({});
  const [boards, setBoards] = useState<MetaModel[]>([]);
  const [institutes, setInstitutes] = useState<MetaModel[]>([]);
  const [classRooms, setClassRooms] = useState<MetaModel[]>([]);
  const [allClassRoom, setAllClassRooms] = useState<any[]>([]);
  const [branches, setBranches] = useState<MetaModel[]>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [sections, setSections] = useState<any>();

  const fetchBoards = () => {
    CommonService.fetchBoardsMeta(
      (data) => {
        const meta = deserialize(MetaModel, data) as MetaModel[];
        setBoards(meta);
        if (meta.length)
          if ((autoFilter && open === false) || user?.roleName === "instituteadmin") {
            setInitialValues({ board: Number(meta[0].value) })
            fetchInstitutes()
          }
      },
      () => { },
      () => { }
    );
  };

  const fetchInstitutes = () => {
    CommonService.fetchInstitutesMeta(
      (data) => {
        const meta = deserialize(MetaModel, data) as MetaModel[];
        setInstitutes(meta);
        if (meta.length)
          if ((autoFilter && open === false) || user?.roleName === "instituteadmin") {
            let value = Number(meta[0].value)
            setInitialValues((prevState) => { return { ...prevState, institute: value } })
            fetchBranches(value)
          }
      },
      () => { },
      () => { }
    );
  };

  const fetchBranches = (id: number) => {
    CommonService.fetchBranchesMeta(
      id,
      (data) => {
        const meta = deserialize(MetaModel, data) as MetaModel[];
        setBranches(meta);
        if (autoFilter && meta.length && open === false) {
          let value = Number(meta[0].value)
          setInitialValues((prevState) => { return { ...prevState, branch: value } })
        }
      },
      () => { },
      () => { }
    );
  };

   const fetchClassRooms = (id: any) => {
      SectionService.fetchBranchClassRooms(
        { branch_id: id },
        (classrooms: any[]) => {
          let meta: any = [];
          classrooms?.map((value: { classRoom: { name: any; id: any; }; id: any; }, index: any) => {
            meta.push({
              label: value?.classRoom?.name,
              value: value?.classRoom?.id,
              id: value.id,
            });
          });
          setClassRooms([...meta]);
          setAllClassRooms([...meta])
        },
        () => { },
        () => { }
      );
    };

  const fetchSections = (id: any) => {

      SectionService.fetchSectionsMeta(
        { branch_class_room_id: id },
        (sections: any) => {
          setSections(sections);
        },
        () => { },
        () => { }
      );
    };

  useEffect(() => {
    fetchBoards();
  }, []);


  useEffect(() => {
    if (initialValues?.board
      && initialValues?.institute
      && initialValues?.branch
      && filterFor == 'StudentPerformance'
      && open === false
      && autoFilter
    ) {
      setDefaultValues({ ...initialValues })
      applyHandler(initialValues)
    } else if (initialValues?.board
      && initialValues?.institute
      && user?.roleName === "instituteadmin"
      && open === false) {
      setDefaultValues({ board: initialValues?.board, institute: initialValues?.institute })
      applyHandler({ board: initialValues?.board, institute: initialValues?.institute })
    }
  }, [initialValues])

  const fetchCount = () => {
    let count = 0;
    if (initialValues?.startingDate) count += 1;
    if (initialValues?.endingDate) count += 1;
    if (initialValues?.board) count += 1;
    if (initialValues?.institute) count += 1;
    if (initialValues?.branch) count += 1;
    if (initialValues?.classRoom) count += 1;
    return count;
  };



  return (
    <Formik initialValues={initialValues} onSubmit={() => { }} enableReinitialize>
      {({ values, setFieldValue, resetForm }) => (
        <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <Dropdown
            overlayClassName="dashboard-filter__overlay"
            className="dashboard-filter"
            trigger={["click"]}
            onOpenChange={(open: boolean) => setOpen(open)}
            open={open}
            overlay={
              <div className="dashboard-filter-form__wrapper">
                <div
                  className="dashboard-filter-form__field"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <label>Date Range</label>
                  <Field
                    name="date"
                    as={RangePicker}
                    value={[values?.startingDate ? moment(values?.startingDate, "YYYY-MM-DD") : undefined, values?.endingDate ? moment(values?.endingDate, "YYYY-MM-DD") : undefined]}
                    onChange={(dates) => {
                      if (dates?.length) {
                        setFieldValue("startingDate", moment(dates?.[0])?.format("YYYY-MM-DD"));
                        setFieldValue("endingDate", moment(dates?.[1])?.format("YYYY-MM-DD"));
                      } else {
                        setFieldValue("startingDate", 0);
                        setFieldValue("endingDate", 0);
                      }

                    }}
                    suffixIcon={
                      <img className="calendar__icon" src={CalendarIcon} />
                    }
                  />
                </div>
                <div
                  className="dashboard-filter-form__field"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <label>Board</label>
                  <Field
                    disabled={user?.roleName === "instituteadmin" ? true : false}
                    as={Select}
                    name="board"
                    placeholder="Select Board"
                    options={boards}
                    value={values?.board}
                    onChange={(value) => {
                      setFieldValue("board", value);
                      fetchInstitutes()
                    }}
                  />
                </div>

                <div
                  className="dashboard-filter-form__field"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <label>Institutes</label>
                  <Field
                    disabled={user?.roleName === "instituteadmin" ? true : false}
                    as={Select}
                    name="institutes"
                    placeholder="Select Institutes"
                    options={institutes}
                    value={values?.institute}
                    onChange={(value) => {
                      setFieldValue("institute", value);
                      setFieldValue("branch", undefined);
                      fetchBranches(value)
                    }}
                  />
                </div>

                <div
                  className="dashboard-filter-form__field"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <label>Branch</label>
                  <Field
                    as={Select}
                    name="branch"
                    placeholder="Select Branch"
                    options={branches}
                    value={values?.branch}
                    onChange={(value) => {
                      setFieldValue("branch", value);
                      setFieldValue("section", undefined);
                      setFieldValue("classRoom", undefined);
                      if (filterFor !== 'StudentPerformance')
                        fetchClassRooms(value)

                    }}
                  />
                </div>

                {filterFor !== 'StudentPerformance' &&
                  <div
                    className="dashboard-filter-form__field"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <label>Class</label>
                    <Field
                      as={Select}
                      name="classRoom"
                      placeholder="Select Class"
                      options={classRooms}
                      value={values?.classRoom}
                      onChange={(value) => {
                        const branch_class_room_id = allClassRoom.find(clsrom => clsrom.value == value)?.id
                        setFieldValue("classRoom", value);
                        setFieldValue("branchClassRoom", branch_class_room_id)
                        fetchSections(branch_class_room_id)
                        setFieldValue("section", undefined);
                      }}
                    />
                  </div>
                }
              {filterFor == 'StudentActivities' &&
                <div
                    className="dashboard-filter-form__field"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <label>Select Section</label>
                    <Field
                      as={Select}
                      name="section"
                      placeholder="Select Section"
                      options={sections}
                      value={values?.section}
                      onChange={(value) => {
                        setFieldValue("section", value);

                      }}
                    />
                  </div>
              }
                <Row gutter={12} className="dashboard-filter__controllers">
                  <Col span={12}>
                    <Button
                      type="default"
                      onClick={() => {
                        if (filterFor == 'StudentPerformance' || user?.roleName === "instituteadmin") {
                          resetForm({ values });
                          setInitialValues(defaultValues)
                          applyHandler(defaultValues)
                        } else {
                          resetForm({});
                          setInitialValues({})
                          clearHandler()
                        }
                      }}
                    >
                      Clear Filters
                    </Button>

                  </Col>
                  <Col span={12}>
                    <Button
                      type="primary"
                      onClick={() => {
                        resetForm({ values });
                        setInitialValues(values);
                        applyHandler(values)
                        setOpen(false)
                      }}
                    >
                      Apply Filters
                    </Button>
                  </Col>
                </Row>
              </div>
            }
          >
            <Badge count={fetchCount()}>
              <div className="filter__icon">
                <img src={FilterIcon} />
              </div>
            </Badge>
          </Dropdown>
        </Form>
      )}
    </Formik>
  );
};

export default AuthContainer(DashboardFilter);
